import { COMMON, HIGH_AVAILABILITY, COSMOSAPITYPES } from './constants';

export const convertMbToGb = (mb) => {
    if (!mb || typeof mb !== 'number') return 0;
    return Math.round(mb / 1024);
};

export const formOrderObjFromCart = (data = null) => {
    const entityDetails = data?.itemDetail?.entityDetails || null;
    const environmentDetails = data?.itemDetail?.catalogService?.catalogConfig?.environmentDetails || null;
    const catalogConfig = data?.itemDetail?.catalogService?.catalogConfig || null;
    return {
        entityDetails: {
            ...entityDetails,
        },

        // Application Section
        appProfile: entityDetails?.name,
        ...(entityDetails?.name && {
            appProfileDetails: {
                label: entityDetails?.name,
                value: entityDetails?.name,
                data: { dataClassification: catalogConfig?.tags?.['pep-dataclassification'] },
            },
        }),
        sector: catalogConfig?.sector || null,
        region: catalogConfig?.region || null,
        environment: environmentDetails?.environment || null,
        applicationName: catalogConfig?.applicationName,
        appShortName: catalogConfig?.applicationShortName,
        hCode: environmentDetails?.costCenter || null,
        ...(environmentDetails?.costCenter && {
            hCodeDetails: { label: environmentDetails?.costCenter, value: environmentDetails?.costCenter, projectName: environmentDetails?.projectName },
        }),
        ...(!environmentDetails?.costCenter && { hCodeDetails: null }),
        appOwner: `${entityDetails?.applicationManagerGpid} - ${entityDetails?.applicationManager}`,
        appOwnerDetails: {
            label: `${entityDetails?.applicationManagerGpid} - ${entityDetails?.applicationManager}`,
            gpid: entityDetails?.applicationManagerGpid,
            name: entityDetails?.applicationManager,
            email: entityDetails?.applicationManagerEmail,
        },
        businessCategory: catalogConfig?.tags?.['pep-business-category'] || null,

        // Resource Group
        cosmosApiType: catalogConfig?.apiType,
        resourceGroup: catalogConfig?.resourceGroup,
        isHighAvailabilityEnabled: catalogConfig?.highAvailabilityEnabled ? HIGH_AVAILABILITY.YES : HIGH_AVAILABILITY.NO,
        availabilityZone: catalogConfig?.availabilityZone,
        geoReplication: catalogConfig?.geoReplica ? COMMON.YES : COMMON.NO,
        // API type NoSql
        ...(catalogConfig?.apiType.toLowerCase() === COSMOSAPITYPES.NOSQL && {
            cosmosDatabaseName: catalogConfig?.cosmosNoSql?.sqlDbAccountName,
        }),
        // API Type MongoDB
        ...(catalogConfig?.apiType.toLowerCase() === COSMOSAPITYPES.MONGODB && {
            cosmosDatabaseName: catalogConfig?.cosmosMongoDB?.mongoDbAccountName,
            mongoResourceName: catalogConfig?.cosmosMongoDB?.mongoDbResourceType,
            mongoDbVersion: catalogConfig?.cosmosMongoDB?.mongoDbVersion,
            clusterTier: catalogConfig?.cosmosMongoDB?.mongoDbClusterTier,
            clusterSize: catalogConfig?.cosmosMongoDB?.mongoDbClusterSize,
            clusterStorage: catalogConfig?.cosmosMongoDB?.mongoDbClusterStorage,
        }),
        // API Type PostgreSQL
        ...(catalogConfig?.apiType.toLowerCase() === COSMOSAPITYPES.POSTGRESQL && {
            cosmosDatabaseName: catalogConfig?.cosmosPostgreSql?.postgreSQLDbAccountName,
            postgreSQLVersion: catalogConfig?.cosmosPostgreSql?.postgreSQLVersion,
            nodeCount: catalogConfig?.cosmosPostgreSql?.postgreSQLDbNodeCount,
            nodeStorage: catalogConfig?.cosmosPostgreSql?.postgreSQLDbNodeStorage,
            nodeCompute: catalogConfig?.cosmosPostgreSql?.postgreSQLDbNodeCompute,
            isHighAvailabilityEnabled: catalogConfig?.cosmosPostgreSql?.isHighAvailabilityEnabled === HIGH_AVAILABILITY.YES,
            availabilityZone: catalogConfig?.cosmosPostgreSql?.environment === COMMON.PRODUCTION ? 'none' : catalogConfig?.cosmosPostgreSql?.availabilityZone,
        }),
        // API Type ApacheGremlin
        ...(catalogConfig?.apiType.toLowerCase() === COSMOSAPITYPES.APACHEGREMLIN && {
            cosmosDatabaseName: catalogConfig?.cosmosApacheGremlin?.gremlinDbAccountName,
        }),
        //  API Type ApacheCassandra
        ...(catalogConfig?.apiType.toLowerCase() === COSMOSAPITYPES.APACHECASSANDRA && {
            cosmosDatabaseName: catalogConfig?.cosmosApacheCassandra?.cassandraDbAccountName,
        }),
        // API Type Table
        ...(catalogConfig?.apiType.toLowerCase() === COSMOSAPITYPES.TABLE && {
            cosmosDatabaseName: catalogConfig?.cosmosTable?.tableDbAccountName,
        }),
        // Access Management
        roleAssignmentRequired: catalogConfig?.roleAssignmentRequired === true ? COMMON.YES : COMMON.NO,
        ...(catalogConfig?.roleAssignmentRequired && {
            nonPrivilegedADGroup: catalogConfig?.isNonPriviledgedAdgroup === true ? COMMON.YES : COMMON.NO,
            ...(catalogConfig?.isNonPriviledgedAdgroup && {
                nonPrivilegedADGroupList: catalogConfig?.readableAdGroupNames?.map((app) => ({
                    readerValue: app,
                    readerInputValue: app,
                })),
            }),
        }),
        catalogCode: data?.itemDetail?.catalogService?.catalogServiceCode,
        catalogType: data?.itemDetail?.catalogService?.catalogType,
        cloudProvider: data?.itemDetail?.catalogService?.cloudProvider,
        cloudService: data?.itemDetail?.catalogService?.cloudService,
        enabledManualBudgetCode: catalogConfig?.enabledManualBudgetCode || true,
        validationStatus: 'clearValidation',
        isTouched: false,
    };
};

export const formOrderObjFromOrderDetails = (catalogServiceId = null, data = null) => {
    const entityDetails = data?.entityDetails || null;
    const catalog = data?.catalogServices?.find((item) => item?.catalogServiceId === catalogServiceId) || null;
    const catalogConfig = catalog?.catalogConfig || null;
    const environmentDetails = catalogConfig?.environmentDetails || null;
    return {
        entityDetails: {
            ...entityDetails,
        },
        // Application Section
        appProfile: entityDetails?.name,
        ...(entityDetails?.name && {
            appProfileDetails: {
                label: entityDetails?.name,
                value: entityDetails?.name,
                data: { dataClassification: catalogConfig?.tags?.['pep-dataclassification'] },
            },
        }),
        sector: catalogConfig?.sector || null,
        region: catalogConfig?.region || null,
        environment: environmentDetails?.environment || null,
        applicationName: catalogConfig?.applicationName,
        appShortName: catalogConfig?.applicationShortName,
        hCode: environmentDetails?.costCenter || null,
        ...(environmentDetails?.costCenter && {
            hCodeDetails: { label: environmentDetails?.costCenter, value: environmentDetails?.costCenter, projectName: environmentDetails?.projectName },
        }),
        ...(!environmentDetails?.costCenter && { hCodeDetails: null }),
        appOwner: `${entityDetails?.applicationManagerGpid} - ${entityDetails?.applicationManager}`,
        appOwnerDetails: {
            label: `${entityDetails?.applicationManagerGpid} - ${entityDetails?.applicationManager}`,
            gpid: entityDetails?.applicationManagerGpid,
            name: entityDetails?.applicationManager,
            email: entityDetails?.applicationManagerEmail,
        },
        businessCategory: catalogConfig?.tags?.['pep-business-category'] || null,

        // Resource Group
        cosmosApiType: catalogConfig?.apiType,
        resourceGroup: catalogConfig?.resourceGroup,
        isHighAvailabilityEnabled: catalogConfig?.highAvailabilityEnabled ? HIGH_AVAILABILITY.YES : HIGH_AVAILABILITY.NO,
        availabilityZone: catalogConfig?.availabilityZone,
        geoReplication: catalogConfig?.geoReplica ? COMMON.YES : COMMON.NO,
        // API type NoSql
        ...(catalogConfig?.apiType.toLowerCase() === COSMOSAPITYPES.NOSQL && {
            cosmosDatabaseName: catalogConfig?.cosmosNoSql?.sqlDbAccountName,
        }),
        // API Type MongoDB
        ...(catalogConfig?.apiType.toLowerCase() === COSMOSAPITYPES.MONGODB && {
            cosmosDatabaseName: catalogConfig?.cosmosMongoDB?.mongoDbAccountName,
            mongoResourceName: catalogConfig?.cosmosMongoDB?.mongoDbResourceType,
            mongoDbVersion: catalogConfig?.cosmosMongoDB?.mongoDbVersion,
            clusterTier: catalogConfig?.cosmosMongoDB?.mongoDbClusterTier,
            clusterSize: catalogConfig?.cosmosMongoDB?.mongoDbClusterSize,
            clusterStorage: catalogConfig?.cosmosMongoDB?.mongoDbClusterStorage,
        }),
        // API Type PostgreSQL
        ...(catalogConfig?.apiType.toLowerCase() === COSMOSAPITYPES.POSTGRESQL && {
            cosmosDatabaseName: catalogConfig?.cosmosPostgreSQL?.postgreSQLDbAccountName,
            postgresVersion: catalogConfig?.cosmosPostgreSQL?.postgreSQLVersion,
            nodeCount: catalogConfig?.cosmosPostgreSQL?.postgreSQLDbNodeCount,
            nodeStorage: catalogConfig?.cosmosPostgreSQL?.postgreSQLDbNodeStorage,
            nodeCompute: catalogConfig?.cosmosPostgreSQL?.postgreSQLDbNodeCompute,
            isHighAvailabilityEnabled: catalogConfig?.cosmosPostgreSQL?.isHighAvailabilityEnabled ? HIGH_AVAILABILITY.YES : HIGH_AVAILABILITY.NO,
            availabilityZone: catalogConfig?.cosmosPostgreSQL?.environment === COMMON.PRODUCTION ? 'none' : catalogConfig?.cosmosPostgreSQL?.availabilityZones,
        }),
        // API Type ApacheGremlin
        ...(catalogConfig?.apiType.toLowerCase() === COSMOSAPITYPES.APACHEGREMLIN && {
            cosmosDatabaseName: catalogConfig?.cosmosApacheGremlin?.gremlinDbAccountName,
        }),
        //  API Type ApacheCassandra
        ...(catalogConfig?.apiType.toLowerCase() === COSMOSAPITYPES.APACHECASSANDRA && {
            cosmosDatabaseName: catalogConfig?.cosmosApacheCassandra?.cassandraDbAccountName,
        }),
        // API Type Table
        ...(catalogConfig?.apiType.toLowerCase() === COSMOSAPITYPES.TABLE && {
            cosmosDatabaseName: catalogConfig?.cosmosTable?.tableDbAccountName,
        }),
        // Access Management
        roleAssignmentRequired: catalogConfig?.roleAssignmentRequired === true ? COMMON.YES : COMMON.NO,
        ...(catalogConfig?.roleAssignmentRequired && {
            nonPrivilegedADGroup: catalogConfig?.isNonPriviledgedAdgroup === true ? COMMON.YES : COMMON.NO,
            ...(catalogConfig?.isNonPriviledgedAdgroup && {
                nonPrivilegedADGroupList: catalogConfig?.readableAdGroupNames?.map((app) => ({
                    readerValue: app,
                    readerInputValue: app,
                })),
            }),
        }),

        catalogCode: catalog?.catalogServiceCode,
        catalogType: catalog?.catalogType,
        cloudProvider: catalog?.cloudProvider,
        cloudService: catalog?.cloudService,
        enabledManualBudgetCode: catalogConfig?.enabledManualBudgetCode || true,
        validationStatus: 'clearValidation',
        isTouched: false,
    };
};

export const resetCostEstimateDetails = {
    details: [],
    qty: null,
    totalOneTimeCost: {
        frequency: 'one time cost',
        estCost: null,
        currency: 'USD',
    },
    totalRecurringCost: {
        frequency: 'per item per month',
        estCost: null,
        currency: 'USD',
    },
    notes: 'Total Est. Cost does not include the DR/backup services cost & any Pepsico internal chargebacks',
};

export const resetOrder = {
    entityDetails: null,
    appProfile: null,
    appProfileDetails: null,
    sector: null,
    sectorDetail: null,
    environment: null,
    region: null,
    regionDetail: null,
    applicationName: null,
    appShortName: null,
    appOwner: null,
    appOwnerDetails: null,
    businessCategory: null,
    hCode: null,
    hCodeDetails: null,

    // Resource
    cosmosApiType: null,
    cosmosApiTypeDetails: null,
    resourceGroup: null,
    resourceGroupDetail: null,
    subscription: null,
    cosmosDatabaseName: null,
    geoReplication: 'No',
    isHighAvailabilityEnabled: 'No',
    autoGrowEnabled: 'No',
    availabilityZone: null,
    availabilityZoneDetail: null,
    clusterSize: null,
    clusterStorage: null,
    clusterTier: null,
    mongoDbVersion: null,
    mongoResourceName: null,
    nodeCompute: null,
    nodeCount: null,
    nodeStorage: null,
    postgresVersion: null,
    // access management
    nonPrivilegedADGroupList: [{ readerValue: '' }],
    nonPrivilegedADGroup: null,
    catalogCode: null,
    catalogType: null,
    cloudProvider: null,
    cloudService: null,
    validationStatus: null,
    isTouched: null,
};

export const resetToggleSspModal = {
    isCost: { costType: '', isCostOpen: false },
    isSubmitOrderSuccess: false,
    isCostSplitOpen: false,
};

export const isDuplicate = (adGroupArray, adGroup) => {
    const duplicateReaderADGroups = adGroupArray?.filter((item, index) => adGroupArray.indexOf(item) !== index);
    if (adGroup) {
        return duplicateReaderADGroups.indexOf(adGroup) > -1;
    }
    return false;
};

export const isADGroupError = (validationMessage = [], adGroup = null) => {
    let errorCount = 0;
    let adGroupError = false;
    if (Array.isArray(validationMessage)) {
        validationMessage?.forEach((item) => {
            if (item.includes(adGroup)) {
                // eslint-disable-next-line no-plusplus
                errorCount++;
            }
        });
    }
    adGroupError = errorCount !== 0;
    return adGroupError;
};
